import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { initialState } from '@/modules/settings/categories/store/categorySlice/initialState.ts'
import { Category } from '@/modules/settings/categories/types/Category.ts'

const categorySlice = createSlice({
  name: 'category',
  initialState,
  reducers: {
    setLoading: (state, action: PayloadAction<boolean>) => {
      state.isLoading = action.payload
    },
    setCategories: (state, action: PayloadAction<Category[]>) => {
      state.categories = action.payload
    },
    setIsCreateModalOpen: (state, action: PayloadAction<boolean>) => {
      state.isCreateModalOpen = action.payload
    },
    setEditId: (state, action: PayloadAction<string | null>) => {
      state.editId = action.payload
    },
    setFilters: (state, action: PayloadAction<string>) => {
      state.filters = action.payload
    },
    reset: () => initialState
  }
})

export const categoryActions = categorySlice.actions
export const { reducer: categoryReducer } = categorySlice
